import React from 'react';
import {BaseModal} from '../comun/Index';

class Modal extends React.Component {
  constructor(props) {
    super(props);
    this.state={}
  }

  componentDidMount(){}

  botones(tipo){
    return (
      [
        {titulo:"Salir", backgroundColor:'orange', onClick: () => this.props.salir()},
        {titulo:"Atiende", backgroundColor:'green', onClick: () => this.props.atiende()},
        {titulo:"No atiende", backgroundColor:'red', onClick: () => this.props.noAtiende()}
      ]
    )
  }

  render(){
    const {tipoModal} = this.props;
    return(
      <BaseModal
        titulo="Persona seleccionada"
        loading={false}
        botonera={this.botones(tipoModal)}
      >
        <h4 style={{textAlign:'center'}}>¿Que accion desea tomar?</h4>
      </BaseModal>
    );
  }
}

export default Modal;
